import { getBaseUrl, getFullBasenamePath } from './helpers/url-domain'

const baseUrl = getBaseUrl()

const config = {
    accountantPortalUrl: import.meta.env.REACT_APP_ACCOUNTANT_PORTAL_URL || '',
    apiUrl: import.meta.env.REACT_APP_API_URL || '',
    apiUrlBookkeeping: import.meta.env.REACT_APP_API_URL_INVOICING || '',
    apiUrlWebsite: `${import.meta.env.REACT_APP_BASE_URL_WEBSITE}wp-json/ts-api`,
    appBasename: getFullBasenamePath(), // Backward compatibility - prefer using getAppUrl() or navigateToApp() directly
    baseUrl,
    bookkeepingReleaseQuarter: import.meta.env.REACT_APP_INCOME_AND_EXPENSE_START_QUARTER,
    bookkeepingReleaseYear: import.meta.env.REACT_APP_INCOME_AND_EXPENSE_START_YEAR,
    cookieDomain: 'taxfix.com',
    enabledQuarterlyTaxReturnsAnnualSummaryTaxYears: [2021, 2022, 2023, 2024],
    enabledQuarterlyTaxReturnTaxYears: [2021, 2022, 2023, 2024, 2025],
    enabledTaxReturnTaxYears: [2019, 2020, 2021, 2022, 2023],
    enabledCompanyTaxReturnTaxYears: [2023, 2024],
    environment: import.meta.env.REACT_APP_ENVIRONMENT || '',
    facebookAppId: undefined,
    firebaseApiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY,
    firebaseAppId: import.meta.env.REACT_APP_FIREBASE_APP_ID,
    firebaseAuthDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    firebaseAuthTenantId: import.meta.env.REACT_APP_FIREBASE_AUTH_TENANT_ID,
    firebaseProjectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
    firebaseRecaptchaEnterpriseSiteKey: import.meta.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY,
    googleReviewsScore: import.meta.env.REACT_APP_GOOGLE_REVIEWS_SCORE,
    googleReviewsUrl: import.meta.env.REACT_APP_GOOGLE_REVIEWS_URL,
    intercomAppId: import.meta.env.REACT_APP_INTERCOM_ID || '',
    isMixpanelEnabled: import.meta.env.REACT_APP_MIXPANEL === 'true',
    isProduction: import.meta.env.REACT_APP_ENVIRONMENT === 'Production',
    isStaging: import.meta.env.REACT_APP_ENVIRONMENT === 'Staging',
    mixpanelApiHost: 'https://api-eu.mixpanel.com',
    mixpanelToken: import.meta.env.REACT_APP_MIXPANEL_TOKEN,
    mobileAppTargetVersion: import.meta.env.REACT_APP_MOBILE_APP_TARGET_VERSION ?? '',
    nylasSchedulerApiUrl: import.meta.env.REACT_APP_NYLAS_SCHEDULER_API_URL,
    privacyUrl: `${import.meta.env.REACT_APP_HOMEPAGE_URL}politica-de-privacidad`,
    postHogHost: import.meta.env.REACT_APP_POSTHOG_HOST,
    postHogKey: import.meta.env.REACT_APP_POSTHOG_KEY,
    sentryDsn: import.meta.env.REACT_APP_SENTRY_DSN || '',
    singularSdkKey: import.meta.env.REACT_APP_SINGULAR_SDK_KEY || '',
    singularSdkSecret: import.meta.env.REACT_APP_SINGULAR_SDK_SECRET || '',
    singularProductId: import.meta.env.REACT_APP_SINGULAR_PRODUCT_ID,
    siteUrl: import.meta.env.REACT_APP_HOMEPAGE_URL || '',
    siteLogoutUrl: `${import.meta.env.REACT_APP_HOMEPAGE_URL}#salir`,
    stripeCallbackUri: baseUrl,
    stripePublicKey: import.meta.env.REACT_APP_STRIPE_PUBLICKEY || '',
    stripeQuarterlyTaxReturnsAnnualSummaryCallbackUri: `${baseUrl}confirmation/quarterlyTaxReturnsAnnualSummary`,
    stripeSubscriptionCallbackUri: `${baseUrl}confirmation/subscription`,
    stripeTaxReturnCallbackUri: `${baseUrl}confirmation/taxReturn`,
    taxReturnOfficialStartDay: import.meta.env.REACT_APP_TAX_RETURN_OFFICIAL_START_DAY,
    taxReturnStartDay: import.meta.env.REACT_APP_TAX_RETURN_START_DAY,
    taxReturnStartMonth: import.meta.env.REACT_APP_TAX_RETURN_START_MONTH,
    termsUrl: `${import.meta.env.REACT_APP_HOMEPAGE_URL}terminos-y-condiciones-generales`,
    whatsappUrl: import.meta.env.REACT_APP_WHATSAPP_URL,
}

export default config
